import { useState, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { commentActions } from '../actions';
import { buildFormDataFromObject } from '../utils/commonUtils';
import { userConstants } from '../constants';
import { createCancelToken } from '../utils/Axios';

/**
 * Custom hook to manage revised comment drafts.
 */
const useRevisedCommentDraftHooks = ({
  workspace_id, 
  content_group_id, 
  update_draft_token,
  inputRef,
  chatText,
  setChatText,
  commentToReplyId,
  uploadedFiles,
  setupChatContent,
  resetChatInputRef,
  chatInputRef,
  commentToEdit,
  readOnly = false
}) => {
  const dispatch = useDispatch();
  const [draft, setDraft] = useState();
  const { activeTab, internal_draft, partner_draft, comment_tab_loading, created_comment } = useSelector((state) => ({
    activeTab: state.comment.activeTab,
    internal_draft: state.comment.internal_draft,
    partner_draft: state.comment.partner_draft,
    created_comment: state.comment.created_comment,
    comment_tab_loading: state.comment.comment_tab_loading
  }));
  const draftRef = useRef();
  const messageRef = useRef();
  const isDraftSetupRef = useRef(false);
  const commentToReplyToRef = useRef();
  const attachmentsRef = useRef([]);
  const initialLoadedRef = useRef(false);

  const messageLoadedRef = useRef(false);
  const replyRefLoadedRef = useRef(false);
  const attachmentLoadedRef = useRef(false);

  useEffect(() => {
    
    return () => {
      if (readOnly) return;

      if (
        draftRef.current &&
        (commentToEdit === null || commentToEdit === undefined) &&
        comment_tab_loading === false &&
        messageLoadedRef.current === true &&
        replyRefLoadedRef.current === true &&
        attachmentLoadedRef.current === true
      ) {

        const callback = (res) => {
          // Handle callback response
          console.log(res)
          dispatch({ type: userConstants.CLEAR_DRAFT, payload: null });
        };

        console.log(draftRef.current)

        let formData = new FormData();
        const { ...objValues } = draftRef.current;
        objValues.description = messageRef.current;
        objValues.parent_id = commentToReplyToRef.current || 0;
        objValues.attachments_attributes = attachmentsRef.current;

        buildFormDataFromObject(formData, objValues, "comment");
  
        const update_param = {
          comment: formData,
          workspace_id,
          content_group_id,
          comment_id: objValues?.id,
          cancel_token: createCancelToken().token,
          callback,
        };

        dispatch(commentActions.updateDraft(update_param));
      }
    };
  }, []);

  useEffect(() => {
    if (readOnly) return;

    if(created_comment){
      dispatch({type: userConstants.DRAFT_COMMENT_LOADING, payload: null }); // This is disabled at setupChatContent
      if(created_comment.internal && activeTab === 'internal_notes'){
        setUpDraft(internal_draft);
      } else if(activeTab === 'discussion')  {
        setUpDraft(partner_draft);
      }
    }

    return () => {
      
    };
  }, [created_comment]);

  useEffect(() => {
    if (readOnly) return;

    if(initialLoadedRef.current === false && internal_draft && partner_draft){
      const new_draft = activeTab === 'internal_notes' ? internal_draft : partner_draft;
      setUpDraft(new_draft);
      console.log(new_draft)

      initialLoadedRef.current = true;
    }
    return () => {
      
    };
  }, [internal_draft, partner_draft]);

  useEffect(() => {
    if(commentToEdit && draftRef.current){
      const internal = activeTab === 'internal_notes';
      if (internal !== draftRef.current?.internal) {
        return;
      }
      
      const callback= (res) => {
        console.log(res)
      }
      dispatch(commentActions.destroyDraft(workspace_id, content_group_id, draftRef.current?.id, internal, callback))
    }

    return () => {
      
    };
  }, [commentToEdit]);

  useEffect(() => {
    if (readOnly) return;

    if (
        activeTab !== undefined && 
        activeTab !== null && 
        inputRef
      ) {
      const new_draft = activeTab === 'internal_notes' ? internal_draft : partner_draft;
      if(new_draft) setUpDraft(new_draft);

      if(isDraftSetupRef.current === false) {
        isDraftSetupRef.current = true;
      } else {
        if (draftRef.current && initialLoadedRef.current && (commentToEdit === null || commentToEdit === undefined) && comment_tab_loading === false){
          // Setup drafft again after submit

          resetChatInputRef();
          console.log('Submit here')

          const callback = (res) => {
            // Handle callback response
            console.log(res)
          };

          console.log(draftRef.current)
  
          let formData = new FormData();
          const { ...objValues } = draftRef.current;
          objValues.description = messageRef.current;
          objValues.parent_id = commentToReplyToRef.current || 0;
          objValues.attachments_attributes = attachmentsRef.current;

          buildFormDataFromObject(formData, objValues, "comment");

          console.log(objValues)
  
          const update_param = {
            comment: formData,
            workspace_id,
            content_group_id,
            comment_id: objValues?.id,
            cancel_token: update_draft_token.token,
            callback,
          };

          dispatch(commentActions.updateDraft(update_param));
        }
      }

    }

    return () => {
    }
  }, [activeTab, inputRef]);

  useEffect(() => {
    if (readOnly) return;

    if (draft && inputRef) {
      console.log(draft)
      attachmentsRef.current = draft.attachments;
      commentToReplyToRef.current = draft.parent_id;
      messageRef.current = draft.description;

      messageLoadedRef.current = true;
      replyRefLoadedRef.current = true;
      attachmentLoadedRef.current = true;

      setupChatContent(draft);
      
      draftRef.current = draft;
    }

    return () => {

    }
  }, [draft, inputRef]);
  
  useEffect(() => {
    if (readOnly) return;
    
    if(
        draftRef.current && uploadedFiles !== undefined &&
        initialLoadedRef.current
      ){
        messageRef.current = chatText;
        commentToReplyToRef.current = commentToReplyId;
        attachmentsRef.current = uploadedFiles;
        attachmentLoadedRef.current = true;
      } else {
        const interval = setInterval(() => {
          if (initialLoadedRef.current) {
            attachmentsRef.current = uploadedFiles;
            attachmentLoadedRef.current = true;
            clearInterval(interval);
          }
        }, 100);
      }
      
    return () => {

    }
  }, [uploadedFiles]);

  useEffect(() => {
    if (draftRef.current && commentToReplyId !== undefined) {
      if (initialLoadedRef.current) {
        commentToReplyToRef.current = commentToReplyId;
        replyRefLoadedRef.current = true;
      } else {
        const interval = setInterval(() => {
        if (initialLoadedRef.current) {
          commentToReplyToRef.current = commentToReplyId;
          replyRefLoadedRef.current = true;
          clearInterval(interval);
        }
        }, 100);
      }
   
    }

    return () => {

    }
  }, [commentToReplyId]);


  useEffect(() => {
    if(draftRef.current && chatText !== undefined && chatText !== null){
      if (initialLoadedRef.current) {
        messageRef.current = chatText;
        messageLoadedRef.current = true;
      } else {
        const interval = setInterval(() => {
        if (initialLoadedRef.current) {
          messageRef.current = chatText;
          messageLoadedRef.current = true;
          clearInterval(interval);
        }
        }, 100);
      }
    }
 
    return () => {

    }
  }, [chatText]);

  const setUpDraft = useCallback((newDraft) => {
    console.log(newDraft)
    setDraft(newDraft); 
    
    setTimeout(() => {
      dispatch({ type: userConstants.UPDATE_DRAFT_COMMENT, payload: null })  
    }, 1000);
  }, []);

  return {
    draft
  };
};

export default useRevisedCommentDraftHooks;